export default __webpack_public_path__ + "static/media/fire_extinguisher.svg";